/**
 * Responsible Gaming View
 */

define(function(require, exports, module) {
    'use strict';

    var PortletView = require('modules/portlet/portlet.view');
    var SelfExclusionView = require('portlets/responsible-gaming/self-exclusion/self-exclusion.view');
    var LimitsView = require('portlets/responsible-gaming/limits/limits.view');
    var TimeoutView = require('portlets/responsible-gaming/timeout/timeout.view');
    var InactivityTimeoutView = require('portlets/responsible-gaming/inactivity-timeout/inactivity-timeout.view');
    var RealityCheckView = require('portlets/responsible-gaming/reality-check/reality-check.view');

    require('widgets/paging.widget');

    module.exports = PortletView.extend({

        accessRules: {
            allow: ['user']
        },

        className: 'responsible-gaming-container',

        render: function() {
            var config = this.options.config;

            this.$el.html(this.tmpl('responsible-gaming'));

            if (config.selfExclusion) {
                this.$('.fn-self-exclusion-container').html(new SelfExclusionView(this.options).render().el);
            }
            if (config.timeout) {
                this.$('.fn-timeout-container').html(new TimeoutView(this.options).render().el);
            }
            // One view handle limits & timer functionality
            if (config.depositLimits || config.sessionTimer) {
                this.$('.fn-limits-container').html(new LimitsView(this.options).render().el);
            }
            if (config.inactivityTimeout) {
                this.$('.fn-inactivity-timeout-container').html(new InactivityTimeoutView(this.options).render().el);
            }
            if (config.realityCheck) {
                this.$('.fn-reality-check-container').html(new RealityCheckView(this.options).render().el);
            }

            return this;
        }
    });
});
